import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services';
import { prepareTel } from 'libs/common';
import { SimpleButton } from 'libs/ui';
import { Contact } from './contact';
import { Content } from './contacts.styled';

export const Contacts = (props) => {
  const { t } = useTranslation();
  const { client } = props;
  const [addform, setAddform] = useState(false);

  const prepare = (data) => {
    if (data) {
      if (data.tel_num) {
        data.tel_num = prepareTel(data.tel_num, '', false);
      }
    }
    return data;
  };

  const [contact, setContact] = useState(prepare(client.contact));

  /**
   * show add form
   */
  const showAddForm = () => {
    setAddform(true);
  };

  /**
   * refresh client
   * @param {*} data
   */
  const refresh = (data) => {
    setAddform(false);
    setContact(data);
  };

  const rightUpdate = user.haveRight('clients.update');

  return (
    <Content>
      {/* add contact */}
      {!contact && rightUpdate && !addform && (
        <SimpleButton onClick={showAddForm}>
          <i className="fa fa-plus" />
          {t('buttons.Добавить контакт')}
        </SimpleButton>
      )}

      {/* add contact form */}
      {addform && <Contact refresh={refresh} clientId={client.id} contact={contact} />}

      {/*  contact */}
      {contact && <Contact refresh={refresh} clientId={client.id} contact={contact} />}
    </Content>
  );
};
